module.exports = __webpack_public_path__ + "static/media/watch.a169f941.svg";